import { resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.modalVisible,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalVisible) = $event)),
    persistent: "",
    "max-width": "600"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, {
            class: "headline font-weight-bold mb-2",
            textContent: _toDisplayString(_ctx.$t('dialog.agbzustimmen.title'))
          }, null, 8, ["textContent"]),
          _createVNode(_component_v_card_text, { class: "pb-0 pt-0" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('dialog.agbzustimmen.text1')) + " ", 1),
                _createElementVNode("u", {
                  style: {"color":"#0d47a1","cursor":"pointer"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.agbLinkClicked && _ctx.agbLinkClicked(...args)))
                }, _toDisplayString(_ctx.$t('dialog.agbzustimmen.text2')), 1)
              ]),
              _createVNode(_component_v_checkbox, {
                modelValue: _ctx.isSigned,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isSigned) = $event)),
                label: _ctx.$t('dialog.agbzustimmen.checkbox.label'),
                "hide-details": ""
              }, null, 8, ["modelValue", "label"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "ml-4 mt-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                ref: "submitButton",
                disabled: !_ctx.isSigned,
                color: "primary",
                variant: "flat",
                class: "modalbutton mb-3",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitAgbDecision(true))),
                textContent: _toDisplayString(_ctx.$t('components.confirmdialog.confirm'))
              }, null, 8, ["disabled", "textContent"]),
              _createVNode(_component_v_btn, {
                class: "modalbutton mb-3",
                variant: "flat",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitAgbDecision(false))),
                textContent: _toDisplayString(_ctx.$t('components.confirmdialog.cancel'))
              }, null, 8, ["textContent"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}